import Head from 'next/head';
import React from 'react';
import StakecutUniversitySection from '../../components/sections/stakecut-university';
import ComingSoon from '../../components/widgets/coming-soon';
import DashboardLayout from '../../components/widgets/dashboard-layout';
import Protected from '../../hoc/protected-route';

const StakecutUniversity = () => {
  return (
    <>
      <Head>
        <title>Stakecut University</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <StakecutUniversitySection />
    </>
  );
};

export default Protected(StakecutUniversity);
